import React, { useState, useEffect } from "react";
import { AppFooter, AppHeader, SideMenu } from "../../components/organisms";
import {
  AnalyticsService,
  notificationSchedulerTime,
  apiPost,
  apiPostWithStatusCode,
} from "../../utils";
import { Spinner, Title } from "../../components/atoms";
import { TabletModal } from "../../components/molecules";
import PartialOrderAcceptanceModal from "../../components/molecules/PartialOrderAcceptanceModal/PartialOrderAcceptanceModal";
import AcceptIcon from "../../assets/images/accept-icon.svg";
import DeclineIcon from "../../assets/images/decline-icon.svg";
import { OrdersInProgressRow } from "../Orders/OrdersInProgress/Detail/OrdersInProgressRow";
import { NewOrdersRow } from "../Orders/NewOrders/Detail/NewOrdersRow";
import { useNavigate } from "react-router-dom";
import { OrderShipmentItem } from "../Orders/OrderShipment/Detail/OrderShipmentItem";
import { DeliveryOrderRow } from "../Orders/OrderDelivery/Detail/OrderRow.js";
import actions from "../../store/actions";
import {
  GETNEWORDERS,
  GETNEWORDERS_V2,
  UPDATEORDERSTATUS,
  SHIPORDER,
  SHIPMEMORABILIAORDER,
  SHIPMEMORABILIAORDERTOCUSTOMER,
  REQUESTMEMORABILIAFEDEXPICKUP,
  SHIPORDERCANCEL,
  REQUESTFEDEXPICKUP
} from "../../api/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router-dom";


const Dashboard = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const showInProgressParam = queryParams.get("showInProgress");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const ErrorText =
    " Sorry, we’ve hit an issue requesting the courier. This can happen,but please be patient and try again in a few minutes.";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Signout = () => {
    const userEmail = localStorage.getItem("userEmail");
    AnalyticsService.logEvent("USER_LOGGED_OUT", {
      userEmail: userEmail,
    });
    AnalyticsService.identifyUser(null);
    localStorage.clear();
    localStorage.setItem("isAuthenticated", false);
    navigate("/");
  };

  const onShipmentDetails = (
    customer,
    time,
    date,
    value,
    orderNumber,
    url,
    customerAddress,
    orderReadyForShipmentDateTime,
    orderId,
    note,
    lineItems
  ) => {
    if (renderNewOrder) dispatch(actions.viewNewOrders());
    else if (renderProgressOrder) dispatch(actions.viewInProgressOrder());
    else if (renderShipmentOrder) dispatch(actions.viewShipmentOrders());
    else if (renderDeliveryOrder) dispatch(actions.viewDeliveryOrders());
    navigate("/readyForShipmentOrderDetails", {
      state: {
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        orderReadyForShipmentDateTime,
        orderId,
        note,
        lineItems
      },
    });
    AnalyticsService.logEvent("READY_FOR_SHIPMENT_ORDER_DETAILS_VIEWED", {
      customerName: customer ? customer : "N/A",
      time: time,
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
      orderReadyForShipmentDateTime: orderReadyForShipmentDateTime,
    });
  };

  const onDeliveryDetails = (
    customer,
    time,
    date,
    value,
    orderNumber,
    url,
    customerAddress,
    orderOutForDeliveryDateTime,
    orderId,
    note,
    lineItems
  ) => {
    if (renderNewOrder) dispatch(actions.viewNewOrders());
    else if (renderProgressOrder) dispatch(actions.viewInProgressOrder());
    else if (renderShipmentOrder) dispatch(actions.viewShipmentOrders());
    else if (renderDeliveryOrder) dispatch(actions.viewDeliveryOrders());
    navigate("/outForDeliveryOrderDetails", {
      state: {
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        orderOutForDeliveryDateTime,
        orderId,
        note,
        lineItems
      },
    });
    AnalyticsService.logEvent("OUT_FOR_DELIVERY_DETAILS_VIEWED", {
      customerName: customer ? customer : "N/A",
      time: time,
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
      orderOutForDeliveryDateTime: orderOutForDeliveryDateTime,
    });
  };

  const onNewOrderDetails = (
    customer,
    time,
    date,
    value,
    orderNumber,
    url,
    customerAddress,
    isNewOrder,
    orderId,
    note,
    lineItems
  ) => {
    if (renderNewOrder) dispatch(actions.viewNewOrders());
    else if (renderProgressOrder) dispatch(actions.viewInProgressOrder());
    else if (renderShipmentOrder) dispatch(actions.viewShipmentOrders());
    else if (renderDeliveryOrder) dispatch(actions.viewDeliveryOrders());
    
    navigate("/newOrderDetails", {
      state: {
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        isNewOrder,
        orderId,
        note,
        lineItems
      },
    });
    AnalyticsService.logEvent("NEW_ORDER_DETAILS_VIEWED", {
      customerName: customer ? customer : "N/A",
      time: time,
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
    });
  };

  const onInProgressOrderDetails = (
    customer,
    time,
    date,
    value,
    orderNumber,
    url,
    customerAddress,
    orderId,
    note,
    lineItems
  ) => {
    toast.dismiss();
    if (renderNewOrder) dispatch(actions.viewNewOrders());
    else if (renderProgressOrder) dispatch(actions.viewInProgressOrder());
    else if (renderShipmentOrder) dispatch(actions.viewShipmentOrders());
    else if (renderDeliveryOrder) dispatch(actions.viewDeliveryOrders());
    navigate("/inProgressOrderDetails", {
      state: {
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        orderId,
        note,
        lineItems
      },
    });
    AnalyticsService.logEvent("IN_PROGRESS_ORDER_DETAILS_VIEWED", {
      customerName: customer ? customer : "N/A",
      time: time,
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
    });
  };

  const onPrintConfirm = async () => {
    var {
      customer,
      time,
      date,
      value,
      orderNumber,
      url,
      customerAddress,
      billing,
      orderId,
      shipLabel,
      returnLabel,
      order
    } = printData;
    
    setShipmentLoader(true);
    try{
      
      
      var response = null;
      if(order.isMemorabilia && !order.isMemorabiliaAtStore)
      {
        response = await apiPost(SHIPMEMORABILIAORDER, {
          orderId:orderId, lineItemId:order.lineItems[0].id
        });
      }
      else if(order.isMemorabilia && order.isMemorabiliaAtStore)
      {
        response = await apiPost(SHIPMEMORABILIAORDERTOCUSTOMER, {
          orderId:orderId, lineItemId:order.lineItems[0].id
        });
      }
      else{
        response = await apiPost(SHIPORDER, {
        orderId
      });
      }

     
     
      if(response.success)
      {
        const {trackingNumber, returnShippingLable, shippingLable} = response.data;
       
        shipLabel = shippingLable;
        returnLabel = returnShippingLable;

      }
      else
      {
       
        setShipmentLoader(false);
        return;
      }
    }
    catch(error)
    {
     
      shipmentErrorToast();
      setShipmentLoader(false);
      return;
    }
   
    setShipmentLoader(false);
    AnalyticsService.logEvent("ORDER_IS_READY_FOR_SHIPMENT", {
      orderID: orderID,
    });
    toast.dismiss();
    if (renderNewOrder) dispatch(actions.viewNewOrders());
    else if (renderProgressOrder) dispatch(actions.viewInProgressOrder());
    else if (renderShipmentOrder) dispatch(actions.viewShipmentOrders());
    else if (renderDeliveryOrder) dispatch(actions.viewDeliveryOrders());
    navigate("/printPackagingSlip", {
      state: {
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        billing,
        orderId,
        shipLabel,
        returnLabel,
        order
      },
    });
    AnalyticsService.logEvent("PRINT_LABEL", {
      customerName: customer ? customer : "N/A",
      time: time,
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
    });
  };
  const onRequestFedexForMemorabilia = (order) => {
    updatePrintState({order});
    setShipmentOpen3(true);
  }
  const onPrintLabelClick = (
    customer,
    time,
    date,
    value,
    orderNumber,
    url,
    customerAddress,
    billing,
    orderId,
    status,
    shipLabel,
    returnLabel,
    order
  ) => {
    console.log("----status",status)
    if (status === 1) 
    {
      updatePrintState({
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        billing,
        orderId,
        status,
        shipLabel,
        returnLabel,
        order
      });

      if(order.isService && order.merchantRecievedService){
        
        navigate("/printPackagingSlip", {
          state: {
            customer,
            time,
            date,
            value,
            orderNumber,
            url,
            customerAddress,
            billing,
            orderId,
            shipLabel,
            returnLabel,
            order
          },});
      }else{
        onOpenPrintModal();
      return;
      }
      
    }
    else if(status === 3)
    {
      updatePrintState({
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        billing,
        orderId,
        status,
        shipLabel,
        returnLabel,
        order
      });
      
      onOpenPrintModal();
      return;
    }
    toast.dismiss();
    if (renderNewOrder) dispatch(actions.viewNewOrders());
    else if (renderProgressOrder) dispatch(actions.viewInProgressOrder());
    else if (renderShipmentOrder) dispatch(actions.viewShipmentOrders());
    else if (renderDeliveryOrder) dispatch(actions.viewDeliveryOrders());
    navigate("/printPackagingSlip", {
      state: {
        customer,
        time,
        date,
        value,
        orderNumber,
        url,
        customerAddress,
        billing,
        orderId,
        shipLabel,
        returnLabel,
        order
      },
    });
    AnalyticsService.logEvent("PRINT_LABEL", {
      customerName: customer ? customer : "N/A",
      time: time,
      date: date,
      orderNumber: orderNumber,
      productURL: url,
      customerAddress: customerAddress ? customerAddress : "N/A",
    });
  };

  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const onCloseModal = () => {
    setOpen(false);
    setSelectedOrder(null);
    AnalyticsService.logEvent("NEW_ORDER_ACCEPT_CANCEL_CLICKED");
  };
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [state, setState] = useState({
    orderID: "",
    count: "",
    countInProgress: "",
    countInShipment: "",
    countInDelivery: "",
  });
  const updateState = (newState) => setState(() => ({ ...state, ...newState }));
  const [printData, setPrintData] = useState({
    customer: "",
    time: "",
    date: "",
    value: "",
    orderNumber: "",
    url: "",
    customerAddress: "",
    billing: "",
    orderId: "",
    shipLabel: "",
    returnLabel: "",
    order:null
  });
  const updatePrintState = (newState) =>
    setPrintData({ ...printData, ...newState });
  const [openDecline, setOpenDeline] = useState(false);
  const onCloseDModal = () => {
    setOpenDeline(false);
    AnalyticsService.logEvent("NEW_ORDER_DECLINE_CANCEL_CLICKED");
  };

  const [shipmentOpen, setShipmentOpen] = useState(false);
  const [shipmentOpen2, setShipmentOpen2] = useState(false);
  const [shipmentOpen3, setShipmentOpen3] = useState(false);
  const [deliveryOpen, setDeliveryOpen] = useState(false);
  const [printOpen, setPrintOpen] = useState(false);
  const [shipmentLoader, setShipmentLoader] = useState(false);
  const [orderLoader, setNewOrderLoader] = useState(false);
  const [deliveryLoader, setDeliveryLoader] = useState(false);
  const [declineLoader, setDeclineLoader] = useState(false);

  const onCloseShipmentModal = () => {
    setShipmentOpen(false);
    AnalyticsService.logEvent("READY_FOR_SHIPMENT_ORDER_CANCEL_CLICKED");
  };
  const onCloseShipmentModal2 = () => {
    setShipmentOpen2(false);
    AnalyticsService.logEvent("READY_FOR_SHIPMENT_ORDER_CANCEL_CLICKED");
  };
  const onCloseShipmentModal3 = () => {
    setShipmentOpen3(false);
    AnalyticsService.logEvent("READY_FOR_SHIPMENT_ORDER_CANCEL_CLICKED");
  };
  const onCloseDeliveryModal = () => {
    setDeliveryOpen(false);
    AnalyticsService.logEvent("OUT_FOR_DELIVERY_ORDER_CANCEL_CLICKED");
  };
  const onOpenPrintModal = () => {
    setPrintOpen(true);
  };
  const onClosePrintModal = () => {
    setPrintOpen(false);
  };
  const [inProgressOrders, setInProgressOrders] = useState();
  const [dispatchedOrders, setDispatchedOrders] = useState();
  const [shipmentOrders, setShipmentOrders] = useState();

  const [inProgressOrdersCount, setInProgressOrdersCount] = useState("");
  const [dispatchedOrdersCount, setDispatchedOrdersCount] = useState("");
  const [shipmentOrdersCount, setShipmentOrdersCount] = useState("");

  const [renderNewOrder, setRenderNewOrder] = useState(true);
  const [renderProgressOrder, setRenderProgressOrder] = useState(false);
  const [renderShipmentOrder, setRenderShipmentOrder] = useState(false);
  const [renderDeliveryOrder, setRenderDeliveryOrder] = useState(false);

  const currentTab = useSelector((state) => state.navigation.currentTab);
  const numOfNewOrders = useSelector(
    (state) => state.notifications.numOfNewOrders
  );

  const [activeStep, setActiveStep] = useState(0);
  const { orderID, count, isService, lineItemId, countInProgress, countInDelivery, countInShipment } =
    state;
  useEffect(() => {
    const interval = setInterval(
      () => getNotifications(),
      notificationSchedulerTime
    );
    return () => clearInterval(interval);
  }, [numOfNewOrders]);

  const getNotifications = async () => {
    if (data && numOfNewOrders >= 0) {
      const response = await apiPostWithStatusCode(GETNEWORDERS, {
        vendor: "The Cricket Store",
      });
      if (response.status === 200) {
        const res = response.data;
        let orderCount = 0;
        if (res.length > 0) {
          const newOrdersArray = res.filter(
            (e) => e.orderStatus === 0 && e.newOrder === true
          );
          orderCount = newOrdersArray.length;
          if (orderCount > numOfNewOrders)
            navigate("/notifications", { state: { count: orderCount } });
        }
      } else {
        setTimeout(async () => {
          await getNotifications();
        }, 10000);
      }
    }
  };
  const onStepChange = (stepNumber) => {
    setActiveStep(stepNumber);
  };
  const onOrderClick = () => {
    toast.dismiss();
    onStepChange(0);
    setRenderNewOrder(true);
    setRenderProgressOrder(false);
    setRenderShipmentOrder(false);
    setRenderDeliveryOrder(false);
    AnalyticsService.logEvent("MENU_BUTTON_NEW_ORDERS_CLICKED");
  };
  const onProgressClick = () => {
    toast.dismiss();
    onStepChange(1);
    setRenderNewOrder(false);
    setRenderProgressOrder(true);
    setRenderShipmentOrder(false);
    setRenderDeliveryOrder(false);
    AnalyticsService.logEvent("MENU_BUTTON_IN_PROGRESS_CLICKED");
  };
  const onShipmentClick = () => {
    toast.dismiss();
    onStepChange(2);
    setRenderNewOrder(false);
    setRenderProgressOrder(false);
    setRenderShipmentOrder(true);
    setRenderDeliveryOrder(false);
    AnalyticsService.logEvent("MENU_BUTTON_READY_FOR_SHIPMENT_CLICKED");
  };
  const onDeliveryClick = () => {
    toast.dismiss();
    onStepChange(3);
    setRenderNewOrder(false);
    setRenderProgressOrder(false);
    setRenderShipmentOrder(false);
    setRenderDeliveryOrder(true);
    AnalyticsService.logEvent("MENU_BUTTON_OUT_FOR_DELIVERY_CLICKED");
  };

  // const checkRouteForLink = () => {
  //   console.log("here");
  //   const searchParams = new URLSearchParams(window.location.search);
  //   const showInProgressParam = searchParams.get("showInProgress");

  //   // Use the value of the query parameter
  //   console.log(showInProgressParam);

  //   const value = Number(showInProgressParam);
  //   if (value === 1) {
  //     onProgressClick();
  //     return;
  //   }
  // };

  useEffect(() => {
    dispatch(actions.clearNumOfNEwOrders());
    if (currentTab && currentTab === "NewOrders") onOrderClick();
    else if (currentTab && currentTab === "InProgress") onProgressClick();
    else if (currentTab && currentTab === "ReadyForShipment") onShipmentClick();
    else if (currentTab && currentTab === "OutForDelivery") onDeliveryClick();
    getNewOrders();
    AnalyticsService.logEvent("DASHBOARD_SCREEN");
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, []);

  const getNewOrders = async () => {
    setIsLoading(true);
    const response = await apiPostWithStatusCode(GETNEWORDERS_V2, {
      vendor: "The Cricket Store",
    });
    if (response.status === 200) {
      const res = response.data;
      if (res) {
        setData(res);
        const countValue = res.filter((e) => e.orderStatus === 0);
        const newValue = countValue.length;
        const newOrdersArray = res.filter(
          (e) => e.orderStatus === 0 && e.newOrder === true
        );
        let orderCount = newOrdersArray.length;
        AnalyticsService.logEvent("NEW_ORDERS_ON_DASHBOARD", {
          New_Orders_Count: newValue,
        });
        const orders = res.filter(({ orderStatus }) => {
          return orderStatus === 1;
        });
        const inProOrders = orders.length;
        setInProgressOrdersCount(inProOrders);
        setInProgressOrders(orders);
        AnalyticsService.logEvent("INPROGRESS_ORDERS_ON_DASHBOARD", {
          InProgress_Orders_Count: inProOrders,
        });
        const shipmentOrderss = res.filter(({ orderStatus }) => {
          return orderStatus === 2;
        });
        const inShipOrders = shipmentOrderss.length;
        setShipmentOrdersCount(inShipOrders);
        setShipmentOrders(shipmentOrderss);
        AnalyticsService.logEvent("READY_FOR_SHIPMENT_ORDERS_ON_DASHBOARD", {
          Ready_For_Shipment_Orders_Count: inShipOrders,
        });
        const deliveryOrders = res.filter(({ orderStatus }) => {
          return orderStatus === 3;
        });
        const inDelivOrders = deliveryOrders.length;
        setDispatchedOrdersCount(inDelivOrders);
        setDispatchedOrders(deliveryOrders);
        AnalyticsService.logEvent("OUT_FOR_DELIVERY_ORDERS_ON_DASHBOARD", {
          Out_For_Delivery_Orders_Count: inDelivOrders,
        });
        updateState({
          count: newValue,
          countInProgress: inProOrders,
          countInShipment: inShipOrders,
          countInDelivery: inDelivOrders,
        });
        dispatch(actions.updateNumOfNewOrders(orderCount));
      }
      setIsLoading(false);
    } else {
      setTimeout(async () => {
        await getNewOrders();
      }, 5000);
    }
  };

  function shipmentErrorToast() {
    toast(
      (t) => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div>
            <span>{ErrorText}</span>
          </div>
          <div className="toastIconBox" onClick={() => toast.dismiss(t.id)}>
            <img src={DeclineIcon} className="icon" />
            <Title
              text={"Dismiss"}
              className="toastIconSubtitle"
              style={{ fontSize: "12px", marginTop: "5px" }}
            />
          </div>
        </div>
      ),
      {
        duration: 5000,
        position: "top-center",
      }
    );
  }

  const onShipmentConfirm = async () => {
    setShipmentLoader(true);
    try {
      const res = await apiPost(REQUESTFEDEXPICKUP, { orderID });
      if (res.success) {
        onCloseShipmentModal();
        await getNewOrders();
      }
    } catch (error) {
      onCloseShipmentModal();
      shipmentErrorToast();
    }
    setShipmentLoader(false);
  };
  const onShipmentConfirm3 = async () => {
    const {order} = printData;
    console.log("order", order)
    setShipmentLoader(true);
    try {
      const res = await apiPost(REQUESTMEMORABILIAFEDEXPICKUP, { orderId:order.orderId, lineItemId:order.lineItems[0].id });
      if (res.success) {
        onCloseShipmentModal3();
        await getNewOrders();
      }
    } catch (error) {
      onCloseShipmentModal3();
      shipmentErrorToast();
    }
    setShipmentLoader(false);
  };

  const onShipmentCancel = async () => {
    setShipmentLoader(true);
    try {
      const res = await apiPost(SHIPORDERCANCEL, { orderId:isService?lineItemId:orderID, isService:isService });
      if (res.success) {
        onCloseShipmentModal2();
        await getNewOrders();
      }
    } catch (error) {
      onCloseShipmentModal2();
      shipmentErrorToast();
    }
    setShipmentLoader(false);
  };

  const onDeliveryStaus = async () => {
    setDeliveryLoader(true);
    const res = await apiPost(UPDATEORDERSTATUS, {
      orderID,
      status: "OutForDelivery",
    });
    if (res.success) {
      onCloseDeliveryModal();
      setShipmentOrders(undefined);
      setDeliveryLoader(false);
      await getNewOrders();
      AnalyticsService.logEvent("ORDER_IS_DISPATCHED_SUCCESSFULLY", {
        orderID: orderID,
      });
    }
  };

  const onOpenModal = (order) => {
    setOpen(true);
    setSelectedOrder(order);
    AnalyticsService.logEvent("NEW_ORDER_ACCEPT_CLICKED", {
      orderID: order.orderId,
    });
  };
  const onOpenDModal = (orderId, isService) => {
    setOpenDeline(true);
    updateState({
      orderID: orderId, isService:isService
    });
    AnalyticsService.logEvent("NEW_ORDER_DECLINE_CLICKED", {
      orderID: orderId,
    });
  };
  const onOpenShipmentModal = (id) => {
    updateState({
      orderID: id,
    });
    setShipmentOpen(true);
    AnalyticsService.logEvent("REQUEST_FEDEX_CLICKED", {
      orderID: id,
    });
  };
  const onOpenShipmentModal2 = (id, isService, lineItemId) => {
    updateState({
      orderID: id,
      isService:isService,
      lineItemId:lineItemId
    });
    setShipmentOpen2(true);
    AnalyticsService.logEvent("REQUEST_FEDEX_CLICKED", {
      orderID: id,
    });
  };
  const onDispatchModal = (id) => {
    updateState({
      orderID: id,
    });
    setDeliveryOpen(true);
    AnalyticsService.logEvent("CONFIRM_ORDER_DISPATCH_CLICKED", {
      orderID: id,
    });
  };

  const onAcceptOrder = async ({ orderId, acceptAll, lineItemIds }) => {
    setNewOrderLoader(true);
    try {
      const res = await actions.acceptOrder({
        orderId,
        acceptAll,
        lineItemIds,
      });
      if (!res.success) {
        setOpen(true);
      } else {
        setOpen(false);
        const newList = data.filter((item) => item.orderId !== orderId);
        setData(newList);
        navigate(0);
        AnalyticsService.logEvent("NEW_ORDER_SUCCESSFULLY_ACCEPTED", {
          orderID: orderId,
        });
      }
    } catch (error) {
      setOpen(true);
      if (error) {
        AnalyticsService.logEvent("NEW_ORDER_ACCEPT_ERROR", {
          error: error,
        });
      }
    }
    setNewOrderLoader(false);
  };
  const onDeclineOrder = async (id, isService) => {
    setDeclineLoader(true);
    try {
      const res = await actions.updateOrderStatus({
        orderId: id,
        isService:isService,
        status: "Declined",
      });
      if (!res.success) {
        setOpenDeline(true);
      } else {
        setOpenDeline(false);
        const newList = data.filter((item) => item.orderId !== id);
        setData(newList);
        navigate(0);
        AnalyticsService.logEvent("NEW_ORDER_SUCCESSFULLY_DECLINED", {
          orderID: id,
        });
      }
    } catch (error) {
      setOpenDeline(true);
      if (error) {
        AnalyticsService.logEvent("NEW_ORDER_DECLINE_ERROR", {
          error: error,
        });
      }
    }
    setDeclineLoader(false);
  };

  useEffect(() => {
    const value = Number(showInProgressParam);
    if (value === 1) {
      onProgressClick();
    }
  }, [showInProgressParam]);

  return (
    <div className="dashboardSec">
      <div className="topbar">
        <AppHeader Signout={Signout} />
      </div>
      <div className="dashboard-content">
        <div className="sidebar" style={{ width: isTabletOrMobile && "100%" }}>
          <SideMenu
            onNewOrderClick={onOrderClick}
            newOrderActive={activeStep === 0 ? true : false}
            onProgressClick={onProgressClick}
            onProgressActive={activeStep === 1 ? true : false}
            onShipmentClick={onShipmentClick}
            onShipmentActive={activeStep === 2 ? true : false}
            onDeliveryClick={onDeliveryClick}
            onDeliveryActive={activeStep === 3 ? true : false}
          />
        </div>
        <div className={!isTabletOrMobile ? "body" : "body-mobile"}>
          <div className="spinnerDiv">
            <Spinner color={"black"} loading={isLoading} size={40} />
          </div>
          <div className="dashboard-container">
            {renderNewOrder && (
              <div className="w-100">
                <div
                  className={
                    isLoading || count === 0
                      ? "displayNone"
                      : "new-orders-container-progress h-100"
                  }
                >
                  <div className="scrollbar-container">
                    <Title
                      text={
                        count == 1
                          ? `${count} New Order`
                          : `${count} New Orders`
                      }
                      className={"padding text bold lg space-top2"}
                    />
                    {data &&
                      data
                        .filter((e) => e.orderStatus === 0)
                        .map((e) => {
                           console.log("-- shipping ",e.shippingAddress);
                          const isNewOrder = e.newOrder;
                          const dateValue = e.orderDate
                         
                            ? e.orderDate.slice(0, 10)
                            : "N/A";
                          const timeValue = e.orderDate
                            ? e.orderDate.slice(11, 16)
                            : "N/A";
                          const orderVal = e.orderValue.toLocaleString({
                            maximumFractionDigits: 2,
                          });
                          return (
                            <div className="new-orders-screen">
                              <div className={isNewOrder ? "orders-new" : ""}>
                                <NewOrdersRow
                                  key={e.orderId}
                                  viewOnClick={() =>
                                    onNewOrderDetails(
                                      e.customerName,
                                      timeValue,
                                      dateValue,
                                      e.orderValue,
                                      e.orderNo,
                                      e.orderURL,
                                      e.shippingAddress,
                                      e.newOrder,
                                      e.orderId,
                                      e.note,
                                      e.lineItems
                                    )
                                  }
                                  acceptOnClick={() => onOpenModal(e)}
                                  declineOnClick={() => onOpenDModal(e.orderId, e.isService)}
                                  isService={e.isService}
                                  isMemorabilia={e.isMemorabilia}
                                  customerName={
                                    e.customerName ? e.customerName : "N/A"
                                  }
                                  time={timeValue}
                                  orderDate={dateValue}
                                  orderRef={e.orderNo}
                                  orderValue={orderVal}
                                  isNewOrder={isNewOrder}
                                />
                              </div>
                            </div>
                          );
                        })}
                  </div>
                </div>
              </div>
            )}
            {renderProgressOrder && (
              <div className="w-100">
                <div
                  className={
                    isLoading
                      ? "displayNone"
                      : "new-orders-container-progress h-100"
                  }
                >
                  <div className="scrollbar-container d-flex flex-column gap-3">
                    <Title
                      text={`${inProgressOrdersCount} Order${
                        inProgressOrdersCount === 1 ? "" : "s"
                      } In Progress`}
                      className={"padding text bold lg space-top2"}
                    />
                    {inProgressOrders &&
                      inProgressOrders.map((e) => {
                        const dateValue = e.orderDate.slice(0, 10);
                        const timeValue = e.orderDate.slice(11, 16);
                        
                        const orderVal = e.orderValue?.toLocaleString({
                          maximumFractionDigits: 2,
                        });
                        return (
                          <OrdersInProgressRow
                            key={e.orderId}
                            viewOnClick={() =>
                              onInProgressOrderDetails(
                                e.customerName,
                                timeValue,
                                dateValue,
                                e.orderValue,
                                e.orderNo,
                                e.orderURL,
                                e.shippingAddress,
                                e.orderId,
                                e.note,
                                e.lineItems
                              )
                            }
                            customerName={
                              e && e.customerName ? e.customerName : "N/A"
                            }
                            time={timeValue}
                            orderDate={dateValue}
                            orderRef={e.orderNo}
                            orderValue={orderVal}
                            isService={e.isService}
                            isMemorabilia={e.isMemorabilia}
                            merchantRecievedService={e.merchantRecievedService}
                            ordetTrackingID={e.fedexTrackingId}
                            orderReturnTrachingId={e.returnTrackingId}
                            shippingLabel={e.shipmentLabelUrl}
                            onReadyForShipment={() =>
                              onOpenShipmentModal(e.orderId)
                            }
                            printOnClick={() =>
                              onPrintLabelClick(
                                e.customerName,
                                timeValue,
                                dateValue,
                                e.orderValue,
                                e.orderNo,
                                e.orderURL,
                               e.shippingAddress || e.billingAddress,
                                e.billingAddress || e.shippingAddress,
                                e.orderId,
                                e.orderStatus,
                                e.shipmentLabelUrl,
                                e.returnLabelUrl,
                                e
                              )
                            }
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
            {renderShipmentOrder && (
              <div className="w-100">
                <div
                  className={
                    isLoading
                      ? "displayNone"
                      : "new-orders-container-progress h-100"
                  }
                >
                  <div className="scrollbar-container w-100 d-flex gap-3 flex-column h-100">
                    <Title
                      text={`${shipmentOrdersCount} Ready for Shipment`}
                      className={"padding text bold lg space-top2"}
                    />
                    {shipmentOrders &&
                      shipmentOrders.map((e) => {
                       
                        const dateValue = e.orderDate.slice(0, 10);
                        const timeValue = e.orderDate.slice(11, 16);
                        const collectedDate = e.estimatedPickUpTime
                          ? e.estimatedPickUpTime.slice(0, 10)
                          : "N/A";
                        const collectTime = e.estimatedPickUpTime
                          ? e.estimatedPickUpTime.slice(11, 16)
                          : "N/A";
                        const orderVal = e.orderValue.toLocaleString({
                          maximumFractionDigits: 2,
                        });
                        return (
                          <OrderShipmentItem
                            key={e.orderId}
                            customerName={
                              e.customerName ? e.customerName : "N/A"
                            }
                            time={timeValue}
                            orderDate={dateValue}
                            orderValue={orderVal}
                            productUrl={e?.orderURL}
                            collectTime={collectTime}
                            collectedDate={collectedDate}
                            collectedOn={`${collectTime} on ${collectedDate}`}
                            onDispatchClick={() => onDispatchModal(e.orderId)}
                            orderRef={e.orderNo}
                            merchantStartTime={e.vendorStartTime}
                            merchantCloseTime={e.vendorEndTime}
                            viewOnClick={() =>
                              onShipmentDetails(
                                e.customerName,
                                timeValue,
                                dateValue,
                                e.orderValue,
                                e.orderNo,
                                e.orderURL,
                                e.shippingAddress,
                                e.orderReadyForShipmentDateTime,
                                e.orderId,
                                e.note,
                                e.lineItems
                              )
                            }
                            printOnClick={() =>
                              onPrintLabelClick(
                                e.customerName,
                                timeValue,
                                dateValue,
                                e.orderValue,
                                e.orderNo,
                                e.orderURL,
                                e.shippingAddress || e.billingAddress,
                                e.billingAddress || e.shippingAddress,
                                e.orderId,
                                e.orderStatus,
                                e.shipmentLabelUrl,
                                e.returnLabelUrl,
                                e
                              )
                            }
                            cancelFedexOnClick={() =>
                              onOpenShipmentModal2(e.orderId, e.isService, e.lineItems[0].id)
                            }
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
            {renderDeliveryOrder && (
              <div className="w-100">
                <div
                  className={
                    isLoading
                      ? "displayNone"
                      : "new-orders-container-progress h-100"
                  }
                >
                  <div className="scrollbar-container w-100 d-flex gap-3 flex-column h-100">
                    <Title
                      text={`${dispatchedOrdersCount} Out for Delivery`}
                      className={"padding lg text bold  space-top2"}
                    />
                    {dispatchedOrders &&
                      dispatchedOrders.map((e) => {
                        const dateValue = e.orderDate.slice(0, 10);
                        const timeValue = e.orderDate.slice(11, 16);
                        const collectedDate = e.orderOutForDeliveryDateTime
                          ? e.orderOutForDeliveryDateTime.slice(0, 10)
                          : "N/A";
                        const orderVal = e.orderValue.toLocaleString({
                          maximumFractionDigits: 2,
                        });
                        return (
                          <DeliveryOrderRow
                            key={e.orderId}
                            customerName={
                              e && e.customerName ? e.customerName : "N/A"
                            }
                            orderNumber={e.orderNo}
                            orderDate={dateValue}
                            orderRef={e.orderNo}
                            orderValue={orderVal}
                            productUrl={e?.orderURL}
                            isMemorabilia={e.isMemorabilia}
                            isMemorabiliaAtStore={e.isMemorabiliaAtStore}
                            collectedOn={collectedDate}
                            ordetTrackingID={e.fedexTrackingId}
                            hasPrintedMemorabiliaLabesFromStore={e.hasPrintedMemorabiliaLabesFromStore}
                            hasRequestedPickupAtStore={e.hasRequestedPickupAtStore}
                            viewOnClick={() =>
                              onDeliveryDetails(
                                e.customerName,
                                timeValue,
                                dateValue,
                                e.orderValue,
                                e.orderNo,
                                e.orderURL,
                                e.shippingAddress || e.billingAddress,
                                e.orderOutForDeliveryDateTime,
                                e.orderId,
                                e.note,
                                e.lineItems
                              )
                            }
                            printOnClick={() =>
                              onPrintLabelClick(
                                e.customerName,
                                timeValue,
                                dateValue,
                                e.orderValue,
                                e.orderNo,
                                e.orderURL,
                                e.shippingAddress,
                                e.billingAddress,
                                e.orderId,
                                e.orderStatus,
                                e.shipmentLabelUrl,
                                e.returnLabelUrl,
                                e
                              )
                            }
                            requestStorePickup={()=>onRequestFedexForMemorabilia(e)}
                          />
                        );
                      })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedOrder ? (
        <PartialOrderAcceptanceModal
          open={open}
          title={"Accept Order"}
          onCancel={onCloseModal}
          content={"Please confirm you want to accept this order."}
          subContent={"This action can’t be undone."}
          rightBtnText={"ACCEPT ORDER"}
          cancelText={"CANCEL"}
          titleIcon={AcceptIcon}
          onConfirm={({ orderId, acceptAll, lineItemIds }) =>
            onAcceptOrder({ orderId, acceptAll, lineItemIds })
          }
          isLoading={orderLoader}
          selectedOrder={selectedOrder}
        />
      ) : null}
      {/* <TabletModal
        open={open}
        title={"Accept order"}
        onCancel={onCloseModal}
        content={"Please confirm you want to accept this order."}
        subContent={"This action can’t be undone."}
        rightBtnText={"ACCEPT ORDER"}
        titleIcon={AcceptIcon}
        onConfirm={() => onAcceptOrder(orderID)}
        isLoading={orderLoader}
      /> */}
      <TabletModal
        open={openDecline}
        title={"Decline Order"}
        onCancel={onCloseDModal}
        content={"Please confirm you want to decline this order."}
        subContent={"This action can’t be undone."}
        rightBtnText={"DECLINE ORDER"}
        titleIcon={DeclineIcon}
        onConfirm={() => onDeclineOrder(orderID, isService)}
        isLoading={declineLoader}
      />
      <TabletModal
        open={shipmentOpen}
        title={"Ready for Shipment?"}
        onCancel={onCloseShipmentModal}
        content={"Please confirm if the order is ready for shipment."}
        contentDetail={
          "By clicking “confirm”, this will alert FedEx and arrange for a collection to be made."
        }
        subContent={"This action can’t be undone."}
        rightBtnText={"READY FOR SHIPMENT"}
        titleIcon={AcceptIcon}
        onConfirm={onShipmentConfirm}
        isLoading={shipmentLoader}
      />
      <TabletModal
        open={shipmentOpen3}
        title={"Ready for Shipment?"}
        onCancel={onCloseShipmentModal3}
        content={"Please confirm if the order is ready for shipment."}
        contentDetail={
          "By clicking “confirm”, this will alert FedEx and arrange for a collection to be made."
        }
        subContent={"This action can’t be undone."}
        rightBtnText={"READY FOR SHIPMENT"}
        titleIcon={AcceptIcon}
        onConfirm={onShipmentConfirm3}
        isLoading={shipmentLoader}
      />
      <TabletModal
        open={shipmentOpen2}
        title={"Cancel Shipment"}
        onCancel={onCloseShipmentModal2}
        content={"Please confirm if you want to cancel fedex."}
        contentDetail={
          "By clicking “cancel shipment”, this will cancel FedEx on this order."
        }
        subContent={"This action can’t be undone."}
        rightBtnText={"Cancel Shipment"}
        titleIcon={AcceptIcon}
        onConfirm={onShipmentCancel}
        isLoading={shipmentLoader}
      />
      <TabletModal
        open={deliveryOpen}
        title={"Confirm Order Dispatch"}
        onCancel={onCloseDeliveryModal}
        content={"Please confirm you want to accept this order as dispatched."}
        contentDetail={
          "By clicking Confirm, this lets the customer know their order has been collected by Fed Ex and is on the way."
        }
        subContent={"This action cannot be undone."}
        rightBtnText={"CONFIRM"}
        titleIcon={AcceptIcon}
        onConfirm={onDeliveryStaus}
        isLoading={deliveryLoader}
      />
      <TabletModal
        open={printOpen}
        title={"Print Labels?"}
        onCancel={onClosePrintModal}
        content={
          "By clicking “Print label” this will allow you to view and print all labels required for this order."
        }
        contentDetail={""}
        subContent={" Please confirm you’d like to continue."}
        rightBtnText={"CONFIRM"}
        titleIcon={AcceptIcon}
        onConfirm={onPrintConfirm}
        isLoading={shipmentLoader}
      />
      {/* <AppFooter /> */}
    </div>
  );
  //@TCS_END@
};

export default Dashboard;
